import { takeEvery, all, put, select, call } from 'redux-saga/effects';
import actionFactory from '../../webcommon/header/filterheader/actions';
import * as filterHeaderSelectors from '../../webcommon/header/filterheader/selectors';
import * as actions from './actions';
import * as selectors from './selectors';
import * as fileAvailabilityApi from '../../api/fileAvailabilityApi';

const filterHeaderActions = actionFactory('FileAvailability');

function* loadData(api) {
    try {
        yield put(actions.setFileAvailabilityLoading(true));
        const filters = yield select(filterHeaderSelectors.getFilters, 'FileAvailability');
        const runDate = selectors.getDateFrom(filters);
        const result = yield call(api.getFileAvailability, runDate);
        yield put(actions.getFileAvailabilitySuccess(result));
    } catch (error) {
        yield put(actions.getFileAvailabilityFailed('Failed to retrieve files'));
    } finally {
        yield put(actions.setFileAvailabilityLoading(false));
    }
}

function* connected(api) {
    const initialised = yield select(selectors.getInitialised);
    if (!initialised) {
        const filterDefinitions = yield select(selectors.getFilterDefinitions);
        yield put(filterHeaderActions.setFilterDefinitions(filterDefinitions));
        const defaultFilters = yield select(selectors.getDefaultFilters);
        yield put(filterHeaderActions.setDefaultFilters(defaultFilters));
        yield put(actions.setInitialised(true));
        yield put(filterHeaderActions.resetFilters()); // triggers loadData via takeEvery
    } else {
        yield call(loadData, api);
    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.FILE_AVAILABILITY_CONNECTED, connected, fileAvailabilityApi),
        takeEvery(actions.REFRESH_FILE_AVAILABILITY, loadData, fileAvailabilityApi),
        takeEvery([
            filterHeaderActions.UPDATE_FILTER,
            filterHeaderActions.REMOVE_FILTER,
            filterHeaderActions.ADD_FILTER,
            filterHeaderActions.RESET_FILTERS,
        ], loadData, fileAvailabilityApi),
    ]);
}
